import { useClaimHook } from 'hooks/claim.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { TableCell, TableRow, Typography } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { formatPrice } from 'utils/utils';

const ClaimPaymentsTotal = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { claimData: claim } = useSelector((store: RootState) => store.claim);

	const { showTaxColumns } = useClaimHook();

	const {
		amount: {
			total: {
				retailAmount,
				contractualAdjustmentAmount,
				allowablePlanPay,
				memberPayAmount,
				total,
				retailNetOfTax,
				tax,
				grossRetail,
				inStorePromotion,
			},
		},
	} = claim;
	return (
		<TableRow>
			<TableCell scope="row" align="left">
				<Typography variant="bodyLink">
					{tClientLabels('claim.table.total')}:
				</Typography>
			</TableCell>
			<TableCell></TableCell>
			<TableCell></TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{grossRetail ? formatPrice(grossRetail) : formatPrice('0.00')}
				</Typography>
			</TableCell>
			<TableCell></TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{inStorePromotion ? formatPrice(inStorePromotion) : formatPrice('0.00')}
				</Typography>
			</TableCell>
			<TableCell></TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{retailAmount ? formatPrice(retailAmount) : formatPrice('0.00')}
				</Typography>
			</TableCell>
			{showTaxColumns && (
				<>
					<TableCell></TableCell>
					<TableCell align="center">
						<Typography variant="bodyLink">
							{retailNetOfTax ? formatPrice(retailNetOfTax) : formatPrice('0.00')}
						</Typography>
					</TableCell>
					<TableCell></TableCell>
					<TableCell align="center">
						<Typography variant="bodyLink">
							{tax ? formatPrice(tax) : formatPrice('0.00')}
						</Typography>
					</TableCell>
				</>
			)}
			<TableCell></TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{contractualAdjustmentAmount
						? formatPrice(contractualAdjustmentAmount)
						: formatPrice('0.00')}
				</Typography>
			</TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{allowablePlanPay ? formatPrice(allowablePlanPay) : formatPrice('0.00')}
				</Typography>
			</TableCell>
			<TableCell align="center"></TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{memberPayAmount ? formatPrice(memberPayAmount) : formatPrice('0.00')}
				</Typography>
			</TableCell>
			<TableCell align="center"></TableCell>
			<TableCell align="center">
				<Typography variant="bodyLink">
					{total ? formatPrice(total) : formatPrice('0.00')}
				</Typography>
			</TableCell>
		</TableRow>
	);
};

export default ClaimPaymentsTotal;
